import React from "react";

// Iter 89 — Catch-all error boundary for the EMS MDT canvas.
//
// Operational requirement: a render error in the MDT must NEVER produce
// a black screen the crew can't recover from. Without this boundary, a
// thrown ReferenceError during a call-assignment update (iter 81 bug)
// crashed the entire React tree → blank canvas → unit unable to ack the
// call. With this in place the MDT degrades gracefully, surfaces the
// actual JS error to the operator, and exposes a "Reload MDT" button
// that lets the crew get back to a working state without a full restart.
export class MdtErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[MdtErrorBoundary] crashed", error, info);
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="mdt-error-boundary"
          style={{
            width: "100%",
            height: "100%",
            background: "#000",
            color: "#FF6060",
            fontFamily: '"Courier New", monospace',
            padding: 24,
            overflow: "auto",
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 700, color: "#FFD46B", marginBottom: 12 }}>
            MDT DISPLAY ERROR
          </div>
          <div style={{ fontSize: 14, color: "#FFF", marginBottom: 8 }}>
            The MDT screen ran into a rendering error. Your unit is still
            logged in — you can recover the screen by clicking the button
            below. If this happens again, contact dispatch.
          </div>
          <pre
            style={{
              background: "#1A1A1A",
              border: "1px solid #444",
              padding: 10,
              fontSize: 12,
              color: "#FFD46B",
              maxHeight: 200,
              overflow: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {String(this.state.error?.message || this.state.error)}
            {this.state.info?.componentStack ? `\n\n${this.state.info.componentStack}` : ""}
          </pre>
          <button
            data-testid="mdt-error-reload"
            onClick={() => this.setState({ error: null, info: null })}
            style={{
              marginTop: 14,
              padding: "10px 22px",
              background: "#1B7A36",
              color: "#FFF",
              border: "none",
              borderRadius: 3,
              fontWeight: 700,
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            RELOAD MDT
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
